import React from "react";
import Dropzone from "react-dropzone";
import PropTypes from "prop-types";
import styled from "styled-components";

const DropzoneInputContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const DropzoneComponent = ({
  handleOnDrop,
  isDisabled = false,
  className,
  label = "",
  uploadIcon,
}) => {
  return (
    <Dropzone
      disabled={isDisabled}
      onDrop={handleOnDrop}
    >
      {({ getRootProps, getInputProps }) => (
        <section
          className={className}
          {...getRootProps()}
        >
          <DropzoneInputContainer>
            {uploadIcon}
            {label}
            <input {...getInputProps()} />
          </DropzoneInputContainer>
        </section>
      )}
    </Dropzone>
  );
};

DropzoneComponent.prototype = {
  handleOnDrop: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string,
  uploadIcon: PropTypes.element,
};

export default DropzoneComponent;
